<template>
  <v-container :class="internalOpen ? 'pt-2 pb-3' : 'py-1'" :style="internalOpen ? '' : 'background-color: #00000008;'"
    style="border-top: 1px solid #e3e3e3">
    <v-card flat color="transparent" @click="toggleOpen()">
      <v-row no-gutters align="center" :class="internalOpen ? 'mb-3' : ''">
        <v-col cols="auto">
          {{ title ? title : 'Unnamed Group' }}
        </v-col>
        <v-col>
          <v-divider v-show="false" class="mt-1 ml-3 mr-1" />
        </v-col>
        <v-col v-if="appliedFilterCount" cols="auto" class="pr-1">
          <CardBadge :count="appliedFilterCount" />
        </v-col>
        <v-col cols="auto" class="mr-n1">
          <v-btn icon small>
            <v-icon v-text="internalOpen ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-row v-show="internalOpen" no-gutters>
      <v-col cols="12">
        <slot>
          (empty group content)
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardBadge from "@/components/Buttons/CardBadge.vue";

export default {
  name: "FilterGroup",
  model: {
    prop: "open",
    event: "change",
  },
  props: {
    appliedFilters: Array,
    title: String,
    collapsable: {
      default: true,
      type: Boolean,
    },
    open: {
      default: true,
      type: Boolean,
    },
  },
  components: {
    CardBadge,
  },
  mixins: [],

  data() {
    return {
      internalOpen: this.open,
    };
  },

  mounted() {
    this.validateOpen()
  },

  methods: {
    validateOpen() {
      if (this.internalOpen != this.open) {
        this.internalOpen = this.open;
      }
    },

    toggleOpen() {
      this.internalOpen = !this.internalOpen;
      this.$emit('change', this.internalOpen);
    }
  },

  computed: {
    appliedFilterCount() {
      var count = 0;
      if (this.appliedFilters && this.appliedFilters.length) {
        this.appliedFilters.forEach(filter => {
          if (filter instanceof Array) {
            if (filter.length > 0) {
              count++;
            }

          }
          else if (filter) {
            count++;
          }
        });
      }
      return count;
    },
  },

  watch: {
    open: function () {
      this.validateOpen()
    }
  },
};
</script>

<style lang="scss" scoped></style>